import type { TCreditFormCommonFields } from 'entities/creditForm';

export class Agreements {
  constructor(
    private readonly agreement: Pick<Partial<TCreditFormCommonFields>, 'userAgreement' | 'advertisingAgreement'>,
    // eslint-disable-next-line no-empty-function
  ) {}

  profile() {
    return {
      userAgreement: this.agreement.userAgreement || false,
      advertisingAgreement: this.agreement.advertisingAgreement || false,
    };
  }
}
